import { isEqual } from "lodash";
import { createDirtyChecker } from "../../gvc/testNewForm/createDirtyChecker";
import { inputToIdentity } from "../utils";

export function getDirtyChecker(id: string) {
  return createDirtyChecker(id, inputToIdentity, (initItem, currItem, initRaw, currRaw) => {
    const dirty: Record<string, boolean> = {};
    if (!isEqual(initItem.description, currItem.description)) dirty.description = true;
    if (!isEqual(initItem.aws, currItem.aws)) dirty.aws = true;
    if (!isEqual(initItem.azure, currItem.azure)) dirty.azure = true;
    if (!isEqual(initItem.gcp, currItem.gcp)) dirty.gcp = true;
    if (!isEqual(initItem.ngs, currItem.ngs)) dirty.ngs = true;
    if (!isEqual(initItem.tags, currItem.tags)) dirty.tags = true;
    // Network resource sub-types: combined in output, separate in form
    if (!isEqual(initRaw.networkResources.fqdn, currRaw.networkResources.fqdn)) {
      dirty["networkResources-fqdn"] = true;
    }
    if (!isEqual(initRaw.networkResources.ip, currRaw.networkResources.ip)) {
      dirty["networkResources-ip"] = true;
    }
    if (!isEqual(initRaw.nativeNetworkResources.aws, currRaw.nativeNetworkResources.aws)) {
      dirty["nativeNetworkResources-aws"] = true;
    }
    if (!isEqual(initRaw.nativeNetworkResources.gcp, currRaw.nativeNetworkResources.gcp)) {
      dirty["nativeNetworkResources-gcp"] = true;
    }
    return dirty;
  });
}
